module.exports = __webpack_public_path__ + "static/media/seats-checkin.e071a9ae.png";